export default __webpack_public_path__ + "66cc6d585afda0285fa31c07e7721842.png";